module.exports = __webpack_public_path__ + "static/26-64c00ffee4b189be90ef727ab8841a3d.jpg";